<template>
  <el-table :data="items" border row-key="id">
    <el-table-column label="风险" width="90" align="center">
      <template slot-scope="scope">
        <el-tag size="mini" :type="levelType(scope.row.risk_level)">
          {{ levelText(scope.row.risk_level) }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="内容" min-width="260">
      <template slot-scope="scope">
        <div class="title">{{ scope.row.title || scope.row.item_source_id || '内容标题缺失' }}</div>
        <a
          v-if="scope.row.source_url"
          class="source-link"
          :href="scope.row.source_url"
          target="_blank"
          rel="noopener"
        >
          查看原文
        </a>
      </template>
    </el-table-column>
    <el-table-column label="风险结论" min-width="280">
      <template slot-scope="scope">
        <div class="summary">{{ scope.row.risk_summary || evidence(scope.row) }}</div>
      </template>
    </el-table-column>
    <el-table-column label="平台" width="105" align="center">
      <template slot-scope="scope"><platform-tag :value="scope.row.platform" /></template>
    </el-table-column>
    <el-table-column label="负责人" width="110">
      <template slot-scope="scope">{{ scope.row.assignee || '待分配' }}</template>
    </el-table-column>
    <el-table-column label="处理状态" width="110" align="center">
      <template slot-scope="scope">
        <el-tag size="mini" :type="statusType(scope.row.process_status)">
          {{ scope.row.process_status || '待确认' }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="更新时间" width="165">
      <template slot-scope="scope">{{ formatDate(scope.row.updated_at) }}</template>
    </el-table-column>
    <el-table-column label="操作" width="90" align="center">
      <template slot-scope="scope">
        <el-button type="text" @click="$emit('open', scope.row)">查看处理</el-button>
      </template>
    </el-table-column>
    <div slot="empty" class="empty-state">
      <i class="el-icon-circle-check" />
      <strong>没有符合当前条件的风险记录</strong>
      <span>可以调整风险等级、处理状态或搜索条件</span>
    </div>
  </el-table>
</template>

<script>
import PlatformTag from './PlatformTag.vue'

export default {
  name: 'YuqingRiskTable',
  components: { PlatformTag },
  props: ['items'],
  methods: {
    levelText (value) {
      return ({ high: '高', medium: '中', low: '低' })[value] || value || '待确认'
    },
    levelType (value) {
      const level = this.levelText(value)
      return level === '高' ? 'danger' : (level === '中' ? 'warning' : 'info')
    },
    statusType (value) {
      if (value === '已关闭') return 'success'
      if (value === '误报') return 'info'
      if (value === '处理中') return 'warning'
      return 'danger'
    },
    evidence (row) {
      const terms = row.matched_terms
      if (Array.isArray(terms) && terms.length) return `命中词：${terms.join('、')}`
      if (typeof terms === 'string' && terms.trim()) return `命中词：${terms}`
      return '等待补充风险结论'
    },
    formatDate (value) {
      if (!value) return '-'
      const date = new Date(value)
      return Number.isNaN(date.getTime())
        ? String(value)
        : date.toLocaleString('zh-CN', { hour12: false })
    }
  }
}
</script>

<style scoped>
.title {
  color: #303133;
  font-weight: 500;
  line-height: 1.5;
}
.source-link {
  display: inline-block;
  margin-top: 5px;
  font-size: 12px;
}
.summary {
  display: -webkit-box;
  overflow: hidden;
  color: #606266;
  line-height: 1.55;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.empty-state {
  display: flex;
  min-height: 180px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
}
.empty-state i {
  margin-bottom: 12px;
  color: #67c23a;
  font-size: 32px;
}
.empty-state strong {
  margin-bottom: 6px;
  color: #606266;
  font-size: 15px;
  font-weight: 500;
}
.empty-state span {
  font-size: 13px;
}
</style>
